__webpack_require__.p = "https://techminds.pstatic.net/pkgtour/statics/vertical-v2/0b6d69379a22ee19027cc6d4834ddc368bccb553/_next/";